var React = require('react');

function XMark (props) {
    return React.createElement("svg",props,[React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"1.5","strokeLinecap":"round","strokeMiterlimit":"10","x1":"13.5","y1":"2.5","x2":"2.5","y2":"13.5","key":0}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"1.5","strokeLinecap":"round","strokeMiterlimit":"10","x1":"2.5","y1":"2.5","x2":"13.5","y2":"13.5","key":1})]);
}

XMark.displayName = "XMark";

XMark.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","enableBackground":"new 0 0 16 16","xmlSpace":"preserve"};

module.exports = XMark;

XMark.default = XMark;



//////////////////
// WEBPACK FOOTER
// ../icon/src/icons/xMark.svg
// module id = ../icon/src/icons/xMark.svg
// module chunks = 0